import axios from 'axios';

import { getUrlParams } from '@/helpers/pagination';

const CancelToken = axios.CancelToken;
let source;

const actions = {
  getUsers: ({ commit }, filters) => {
    Object.keys(filters).forEach(function(key){
      if(filters[key]) {
        if (Array.isArray(filters[key])) {
          filters[key] = filters[key].map(val => encodeURIComponent(val));
        } else {
          filters[key] = encodeURIComponent(filters[key]);
        }
      }
    });
    const filtersString = getUrlParams(filters);

    if (source) {
      source.cancel();
    }
    
    source = CancelToken.source();
    return axios.get('/users?' + filtersString, { cancelToken: source.token }).then(r => {
      source = undefined;
      return r.data.data;
    }).catch(error => {
      if (!axios.isCancel(error)) {
        throw error;
      }
    });
  },

  getUser: ({ commit }, id) => {
    return axios.get('/users/' + id).then(r => r.data.data);
  },

  getProjects: () => {
    return axios.get('/users/projects').then(r => r.data.data);
  },

  getCountries: () => {
    return axios.get('/users/countries').then(r => r.data.data);
  },

  getLanguages: () => {
    return axios.get('/users/languages').then(r => r.data.data);
  },

  getTimeZones: () => {
    return axios.get('/users/time_zones').then(r => r.data.data);
  },

  getAclData: () => {
    return axios.get('/users/acl_data').then(r => r.data.data);
  },

  saveUser: ({ commit }, data) => {
    if (data && data.country) {
      data.country = data.country.toUpperCase();
    }
    return axios.put('/users/' + data.id, data);
  },

  createUser: ({ commit }, data) => {
    if (data && data.country) {
      data.country = data.country.toUpperCase();
    }
    return axios.post('/users', data);
  }

}

export default {
  namespaced: true,
  actions
};